<!--
    * @Description:
    * @Version: 2.0
    * @Autor: 胡彩丽 hucaili@qfei.cn
    * @LastEditors: 胡彩丽 hucaili@qfei.cn
   -->
<template>
  <div :class="['comp-xl-tab', props.fromPage == 'detail' ? 'comp-xl-detail-tab' : '']">
    <!-- 顶部tab -->
    <template v-if="props.fromPage == 'list'">
      <template v-if="tabList?.length > 0">
        <template v-if="props.entity == 1 && identifying">
          <span class="arco-card-pool-header">线索池</span>
        </template>
        <template v-else>
          <xl-tabs ref="tabsRef" :hasOptSlot="hasOptSlot" is-allow-edit :font-size="14" :entity="entity" :fromPage="fromPage" :isDrag="true" @selectTab="handleTabClick" @changeTab="changeTab" @changeTabName="changeTabName" :tabs="tabList" :default-active="defaultActiveKey" :field-name="{ title: 'name', key: 'id', slotKey: 'more' }">
            <template v-if="hasOptSlot" #more="{ data, index }">
              <jw-dropdown position="bl">
                <span class="view-more">
                  <qfei-icon-more-one-outlined class="view-more-icon" />
                </span>
                <template #content>
                  <jw-doption v-if="index > 0" @click="operateView(1, data, index)">设为首个视图</jw-doption>
                  <jw-doption @click="resetName(data)">重命名</jw-doption>
                  <jw-doption @click="operateView(2, data, index)">编辑视图</jw-doption>
                  <jw-doption @click="operateView(3, data, index)">复制视图</jw-doption>
                  <jw-doption v-if="data.type != '10'" @click="operateView(4, data, index)">删除视图</jw-doption>
                </template>
              </jw-dropdown>
            </template>
            <template v-if="hasOptSlot" #extraAction>
              <div class="view-action">
                <div class="view-action-icon"></div>
                <jw-dropdown trigger="hover" position="bl">
                  <jw-tooltip :content="$t('新建视图')">
                    <span class="view-action-outlined">
                      <qfei-icon-add-two-outlined v-if="!isRequest" class="extra-action" />
                      <icon-loading v-else class="extra-action" />
                    </span>
                  </jw-tooltip>
                  <template #content>
                    <jw-doption @click="addFirstView()">
                      <qfei-icon-table-outlined />
                      {{ $t('表格视图') }}
                    </jw-doption>
                    <jw-doption @click="openDashBoardModal" v-if="grayList?.['Layout:boardView']">
                      <qfei-icon-kanban-outlined />
                      {{ $t('看板视图') }}
                    </jw-doption>
                  </template>
                </jw-dropdown>
              </div>
            </template>
          </xl-tabs>
        </template>
      </template>
      <template v-else>
        <template v-if="loading">
          <qf-dot-animation />
        </template>
      </template>
    </template>
    <!-- 详情内容 -->
    <template v-if="props.fromPage == 'detail' && tabList?.length > 1">
      <div class="select-content">
        <span class="title">请选择视图</span>
        <jw-select :trigger-props="{ updateAtScroll: true }" v-model="defaultActiveKey" placeholder="请选择视图" class="system-form-item-fields" :options="updateOptions" allow-search @change="handleTabClick"> </jw-select>
      </div>
    </template>
    <vu ref="vuRef" v-if="isViewUpdate" :entity="props.entity" @cb="cbVu"></vu>
    <dashboard-group-field @cb="createDashboardView" ref="dashboardRef" />
  </div>
</template>

<script setup>
import { QfeiIconTableOutlined, QfeiIconHyperlinkOutlined, QfeiIconKanbanOutlined, QfeiIconMoreOneOutlined, QfeiIconAddTwoOutlined } from '@qfei-design/icons-vue';
import { tableService } from '@/api/';
import { setService } from '@/api';
import { tools } from '@/utils/tools';
import { Message, Modal } from '@arco-design/web-vue';
import { ref, onMounted, inject, defineAsyncComponent, computed, nextTick } from 'vue';
import useLoading from '@/hooks/loading';
import { useRoute } from 'vue-router';
import { useUserStore, useLayoutStore, useGrayscaleStore } from '@/store';
import _ from 'lodash';
import DashboardGroupField from '@/components/dashboard-group-field/dashboard-group-field.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import { zhiShuOrgId, zhiShuOrgViewIds, hyzbOrgId, hyzbOrgViewIds } from '@/utils/const';
const vu = defineAsyncComponent(() => import('@/views/setting/sys-fields/page-layout/components/view-update/view-update.vue'));
const useLayout = useLayoutStore(); //视图及布局store
const { userInfo } = useUserStore(); //用户信息
const route = useRoute();
console.log(53333, route);
const { grayList } = useGrayscaleStore();
const tabsRef = ref();
const props = defineProps({
  entity: {
    type: [String, Number],
    default: 12
  },
  viewId: {
    type: Number,
    default: 0
  },
  fromPage: {
    type: String,
    default: 'list'
  }
});
const emits = defineEmits(['cb', 'detailCb', 'viewCb']);
const identifying = inject('defaultParams')?.identifying || false; //线索池
const tabList = ref([]); //tab
const updateOptions = ref();
// const objectFeilds = ref([]);//字段列表
const defaultActiveKey = ref(0); //默认激活的tab
const { loading, setLoading } = useLoading(false); //loading
// const defaultViewId = ref(props.viewId);

const dashboardRef = ref();
const openDashBoardModal = () => {
  dashboardRef.value.open(props.entity);
};
const createDashboardView = ({ groupField }) => {
  addFirstView(null, groupField);
};
const checkedViewChange = (viewId, entity) => {
  if (!useLayout || !viewId || !entity) return;
  // 确保 store 状态正常
  if (!useLayout.changeViewId || typeof useLayout.changeViewId !== 'object') {
    useLayout.changeViewId = {};
  }
  return useLayout.viewChange(viewId, entity);
};
const vuRef = ref();
const isRequest = ref(false);
//创建视图
const addFirstView = async (viewId = null, groupField = null) => {
  if (isRequest.value) {
    Message.warning(t('创建视图中，请稍后'));
    return;
  }
  isRequest.value = true;
  try {
    const params = {
      entityType: props.entity,
      viewClass: groupField ? '30' : '10',
      groupField: groupField || undefined
    };
    if (viewId !== null) {
      params.oldViewId = viewId;
    }
    const res = await setService.addLayoutDirect(params);
    const result = res?.result || {};
    if (!res?.error) {
      await getView({ entity: props.entity }, result?.id);
      tabsRef.value.setEditInfo({
        id: result?.id,
        name: result?.name
      });
      checkedViewChange(result.id, result.entityType || props.entity); //更新视图id
    } else {
      Message.error(res?.error?.msg || $t('操作失败'));
    }
    isRequest.value = false;
  } catch (e) {
    console.log(e);
    isRequest.value = false;
  }
};
const hasOptSlot = computed(() => {
  return props.entity != 101 && userInfo?.roles?.indexOf(props.entity >= 200 ? 'object:custom' : 'object:system') > -1;
});
// 编辑视图回调
const cbVu = async (params) => {
  isViewUpdate.value = false;
  if (!params.isRefresh) return;
  await getView({ entity: props.entity }, params.id);
  emits('viewCb');
};

//列表路由追加viewId参数
const addViewId = (viewId = defaultActiveKey.value) => {
  // 使用history.replaceState静态追加参数，避免页面重新加载
  const url = new URL(window.location.href);
  url.searchParams.set('viewId', viewId);
  console.log('更新地址', viewId);
  // 只在URL实际发生变化时才执行replaceState，
  if (url.href !== window.location.href) {
    window.history.replaceState(null, '', url.href);
  }
};

//获取对象下的视图
const getView = async (params, cbViewId = null) => {
  setLoading(true);
  tabList.value = [];
  try {
    const json = await tableService.getViewAndGroup(params);
    setLoading(false);
    if (json?.error) {
      return;
    }
    const r = json?.result || [];
    tabList.value = r;
    // 判断没有视图的场景
    if (!r.length) {
      emits('cb', {
        viewId: 0,
        refresh: false,
        hasGroup: false,
        selectTab: undefined,
        tabList: []
      });
      return;
    }
    // 这里是学冬让做的 仅针对3租户 智书的 特殊逻辑 s
    if (userInfo?.orgId === zhiShuOrgId) {
      if (props.entity === 2) {
        if (route.path?.indexOf('/customer-sales') > -1) {
          tabList.value = r.filter((el) => zhiShuOrgViewIds.includes(el.id));
        } else {
          tabList.value = r.filter((el) => !zhiShuOrgViewIds.includes(el.id));
        }
      }
    }
    // 这里是学冬让做的 仅针对3租户 智书的 特殊逻辑  e

    // 这里是学冬让做的 仅针对华映385租户 智书的 特殊逻辑 s
    if (userInfo?.orgId === hyzbOrgId) {
      if (props.entity === 1) {
        if (route.path?.indexOf('/hy-leads') > -1) {
          tabList.value = r.filter((el) => hyzbOrgViewIds.includes(el.id));
        } else {
          tabList.value = r.filter((el) => !hyzbOrgViewIds.includes(el.id));
        }
      }
    }
    // 这里是学冬让做的 仅针对华映385租户 智书的 特殊逻辑  e
    tabList.value = tabList.value?.map((rc) => {
      return {
        ...rc,
        icon: rc?.type == 30 ? QfeiIconHyperlinkOutlined : rc?.viewClass == '30' ? QfeiIconKanbanOutlined : QfeiIconTableOutlined
      };
    });

    //过滤30外链类型
    updateOptions.value = tabList.value
      ?.filter((tl) => tl?.type != '30')
      ?.map((item) => {
        return { label: item.name, value: item.id };
      });
    let _queryViewId = route.query?.viewId || null;
    //   console.log('_queryViewId', route.query,route.params);
    if (route.params?.id?.indexOf('-') > -1) {
      //移动端路由兼容
      const _routeParams = route.params?.id?.split('-');
      _queryViewId = _routeParams?.[2] || null;
    }

    //如果链接中带有viewId参数 且视图列表中存在这个视图id，则选择这个视图id
    if (_queryViewId && tabList.value.find((item) => item.id == _queryViewId)) {
      defaultActiveKey.value = _queryViewId;
    } else {
      //本地存储的视图id是否在视图列表中，否则选择第一个视图id
      const sessionTabKey = useLayout?.changeViewId?.[props.entity] || null;
      if (tabList.value.find((item) => item.id == sessionTabKey)) {
        defaultActiveKey.value = sessionTabKey;
      } else {
        //如果本地存储的视图id不在视图列表中，则选择第一个视图id
        defaultActiveKey.value = tabList.value[0]?.id;
      }
    }
    // 新增跳转最新的视图
    if (cbViewId && tabList.value?.find((item) => item.id == cbViewId)) defaultActiveKey.value = cbViewId;
    if (props.fromPage == 'list') {
      addViewId(); //追加viewId参数
    }
    checkedViewChange(defaultActiveKey.value, props.entity);

    const defaultViewInfo = tabList.value?.find((item) => item.id == defaultActiveKey.value);
    console.log(defaultViewInfo, 'console.log(defaultViewInfo');
    if (props.fromPage == 'list') {
      //列表
      emits('cb', {
        viewId: defaultActiveKey.value,
        dataPermission: defaultViewInfo?.dataPermission || 0,
        refresh: false,
        businessData: defaultViewInfo?.businessData,
        viewClass: defaultViewInfo?.viewClass,
        hasGroup: defaultViewInfo?.hasGroup,
        groupInfo: defaultViewInfo?.groupInfo,
        selectTab: defaultViewInfo?.type == 30 ? defaultViewInfo : undefined,
        tabList: tabList.value
      });
    } else {
      //详情
      emits('detailCb', { viewId: defaultActiveKey.value, refresh: false });
    }
  } catch (e) {
    console.log(e);
    setLoading(false);
  }
};
// 当用户清除分组或添加分组后需要将分组信息更新到tabList中，因为不刷新或不切换对象，不会调用视图接口，所以需要手动更新
const resetHasGroup = (params) => {
  const { viewId, hasGroup, groupInfo } = params;
  tabList.value.forEach((tl) => {
    if (tl?.id == viewId) {
      tl.hasGroup = hasGroup;
      tl.groupInfo = groupInfo;
    }
  });
};

// 视图排序接口
const viewSort = async (id) => {
  if (tabList.value.length < 2) return false;
  const params = {
    apiIndex: id,
    entity: props.entity,
    point: id,
    elements: tabList.value.map((tab) => tab.id)
  };
  await setService.sortViewV2(params);
};
// 拖拽回调
const changeTab = (e) => {
  if (e?.tabs?.length) {
    tabList.value = _.cloneDeep(e?.tabs);
    viewSort(e.point);
  }
};
const changeTabName = async (info) => {
  try {
    const res = await setService.updateLayoutName({
      viewId: info.id,
      viewName: info.name,
      entityType: props.entity
    });
    if (!res?.error) {
      const _findIndex = tabList.value?.findIndex((tab) => tab?.id == info?.id);
      console.log(_findIndex, info, tabList.value, 'console.log(_findIndex, info, tabList.value');
      if (_findIndex > -1) {
        tabList.value[_findIndex].name = info.name;
      }
    } else {
      Message.error(res?.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};
// 设为首个视图
const moveItemToFirst = (list, index) => {
  const newList = [...list];
  const [targetItem] = newList.splice(index, 1);
  newList.unshift(targetItem);
  return newList;
};

const resetName = (data) => {
  tabsRef.value.setEditInfo({
    id: data?.id,
    name: data?.name
  });
};
const isViewUpdate = ref(true);
// type 类型  data 数据  index 索引
const operateView = (type, data, index) => {
  // 设为首个视图
  if (type === 1) {
    tabList.value = moveItemToFirst(tabList.value, index);
    viewSort(data.id);
  } else if (type === 2) {
    // 编辑视图
    isViewUpdate.value = true;
    nextTick(() => {
      vuRef.value.openDrawer(data.id);
    });
  } else if (type === 3) {
    // 复制视图
    addFirstView(data.id);
  } else if (type === 4) {
    Modal.confirm({
      titleAlign: 'left',
      width: 400,
      simple: false,
      title: '你确定要删除该视图吗？',
      content: '删除后将无法再以此视图样式查看权限组，请确保你的工作不受影响。',
      onOk: async () => {
        await setService.deleteLayoutV2({ id: data.id }).then((res) => {
          console.log(res);
          if (!res.error) {
            Message.success('视图已删除');
            getView({ entity: props.entity });
          } else {
            Message.error(res.error?.msg || '操作失败');
          }
        });
      }
    });
  }
};

// 点击tab
const handleTabClick = (key) => {
  //此处兼容外链容器
  const _selectTab = tabList.value?.find((tl) => tl?.id == key);
  const _businessData = tools.isJSON(_selectTab?.businessData) ? JSON.parse(_selectTab?.businessData) : {};
  if (props.fromPage != 'list' || _selectTab?.type !== '30' || _businessData?.openWith == 2 || _businessData?.openWith == 1) {
    checkedViewChange(key, props.entity); //保存viewId
  }
  if (props.fromPage == 'list') {
    checkedViewChange(key, props.entity); //存储当前选中的实体和视图id
    addViewId(key); //列表路由追加viewId参数
    //列表
    emits('cb', {
      viewId: key,
      refresh: true,
      dataPermission: _selectTab?.dataPermission || 0,
      selectTab: _selectTab,
      viewClass: _selectTab?.viewClass,
      businessData: _selectTab?.businessData,
      hasGroup: _selectTab.hasGroup,
      groupInfo: _selectTab?.groupInfo,
      tabList: tabList.value
    });
  } else {
    emits('detailCb', { viewId: key, refresh: true });
  }
};

onMounted(() => {
  getView({ entity: props.entity });
});

// 设置当前viewId
const setViewId = () => {
  useLayout?.changeViewId?.[props.entity] && (defaultActiveKey.value = useLayout?.changeViewId?.[props.entity]);
};

defineExpose({
  setViewId,
  getView,
  resetHasGroup
});
</script>
<style scoped lang="less">
@import './xl-tab.less';
</style>
